import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { initGA, trackPageView } from '../utils/analytics';

function CookieBanner({ basePath = '' }) {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const consent = localStorage.getItem('cookie_consent');

        if (!consent) {
            setVisible(true);
            return;
        }

        if (consent === 'accepted') {
            initGA();
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookie_consent', 'accepted');
        initGA();
        const currentPath = location.pathname + location.search + location.hash;
        trackPageView(currentPath);
        setVisible(false);
    };

    const handleReject = () => {
        localStorage.setItem('cookie_consent', 'rejected');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="cookie-banner">
            <div className="cookie-banner-content">
                <div>
                    <h3>{t('cookiesBanner.title')}</h3>
                    <p>{t('cookiesBanner.text')}</p>

                    <Link
                        to={`${basePath}/politica/cookies`}
                        className="cookie-policy-link"
                    >
                        {t('cookiesBanner.policy')}
                    </Link>
                </div>

                <div className="cookie-actions">
                    <button
                        type="button"
                        className="cookie-btn cookie-btn-secondary"
                        onClick={handleReject}
                    >
                        {t('cookiesBanner.reject')}
                    </button>

                    <button
                        type="button"
                        className="cookie-btn cookie-btn-primary"
                        onClick={handleAccept}
                    >
                        {t('cookiesBanner.accept')}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CookieBanner;